import { useState } from "react";

export type SortOrder = {
  field: string;
  direction: "asc" | "desc" | "";
};

export const useSorting = ({
  sortField,
  order,
}: {
  sortField?: string;
  order?: "asc" | "desc" | "";
}) => {
  const [sortOrder, setSortOrder] = useState<{
    field: string;
    direction: "asc" | "desc" | "";
  }>({
    field: sortField ?? "",
    direction: order ?? "asc",
  });

  const handleSort = (headerName: string) => {
    console.log(headerName);
    setSortOrder((prevOrder) => {
      const currentOrder =
        prevOrder.field === headerName ? prevOrder.direction : "";
      const newDirection = currentOrder === "asc" ? "desc" : "asc";
      return { field: headerName, direction: newDirection };
    });
  };

  return { sortOrder, handleSort };
};

export const getCommaSeparatedValuesFromArray = (
  array: string[] | null | undefined
) => {
  let combinedValues: string = "";

  if (array && Array.isArray(array) && array.length > 0) {
    array.forEach(
      (value) =>
        (combinedValues = combinedValues
          ? `${combinedValues}, ${value}`
          : value)
    );
  }

  return combinedValues;
};
